import * as amplify from "../util/amplify.ts";
import * as FwDatas from "../FwDatas.ts";
import * as INR from "../INR.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import { markInvalidNative } from "../util/forms.ts";
import * as Locale from "../util/Locale.ts";
import * as libLocation from "../lib/location.ts";
import * as Screen from "../lib/Screen.ts";
import {OS} from "../lib/os.ts";
import {getMainEmailIdentifier} from "../features/email_verify.ts";
import * as segment from "../tracking-segment.ts";


import TPL_quota from "../settings/settings-quota.mustache";
import TPL_members from "../settings/edit_family_members.mustache";
import TPL_admin from "../settings/edit_family_administrator.mustache";
import TPL_download from "../settings/download.mustache";
import TPL_editfamily from "../settings/settings_edit_family.mustache";
import TPL_language from "../settings/language.mustache";
import TPL_password from "../settings/change_password.mustache";
import TPL_credit from "../settings/credits.mustache";
import { addParams } from "../lib/url.ts";
import { getPreference } from "../DarkMode.ts";
import { CreditListCache } from "../server/objects/ICredit.ts";


Html.registerDom({
  mailtosupport(){
    segment.track("Premium Support Tapped",{source_screen:"settings"});
    var
      user = FwDatas.getUser(),
      state = FwDatas.getState(),
      family = FwDatas.getFamily(),
      subject = i18n.get('support.subject'),
      body = `


User ${user.accountId}
${state?.premium?.fWPremiumPopup ? 'Premium true':''}
User-Agent ${navigator.userAgent}
OS ${OS.code}
    `
    window.open(addParams('mailto:support@familyandco.com',{body,subject}))

  }
})

  var
    // id of the default tab, without leading '#'
    DEFAULT_TAB_ID = "settings_edit_members";

  /*
    Function: displayChangePasswordSection()
    Display the section to change the password
  */
  function displayChangePasswordSection(){

    ApiServer['custom.changepassword'] = ApiServer.accchangepassword.prepare(async function(data){
      segment.track("Setting Password Changed");
      await modal.alert("changepassword.messageSuccess");
      libLocation.goTo(INR.URL.SETTINGS);
    },function(err){
      if(err.code==="3"){
        const input = document.querySelector('form[data-fw-dyn-action="custom.changepassword"] input[name="password"]') as HTMLInputElement;
        markInvalidNative(input, i18n.get("fw2.apierrors.3"));
      }else{
        throw err;
      }
    })

    var
      emailIdentifier = getMainEmailIdentifier(),
      login;
    if(!emailIdentifier){
      login = FwDatas.getUser().identifiers.filter(identifier => identifier.type === 'Login')[0]
    }
    Html.setHtml(document.getElementById('settings_content'),TPL_password,{
      emailIdentifier,
      login
    });

  }

  /*
    Function: displayPreferences(family)
    Display the section for user preferences

    Parameter:
      family - object, extended family data
  */
  function displayPreferences(family){
    Html.setHtml(document.getElementById('settings_content'),TPL_language,Object.assign({},Locale));
    const
      selector = document.querySelector('#settings_content select') as HTMLSelectElement;

    if(selector){
      selector.value = i18n.getSelectedLanguage();
      if(selector.value !== i18n.getSelectedLanguage()){
        selector.value = i18n.getShortLanguage();
      }
      selector.addEventListener('change',()=>{
        //as state might contains server text depending on the locale we invalidate the state
        FwDatas.setState(undefined);
        ApiServer.accsetprofile({locale:selector.value})
        amplify.publish('refresh')
      })
    }
    const
      darkModePref = getPreference(),
      onclickseek = "darkmode"+(darkModePref===null?'':('|'+darkModePref)),
      darkModeEl = document.querySelector("#settings_content .selectable [data-fw-onclick='"+onclickseek+"']");
    if(darkModeEl){
      darkModeEl.classList.add('selected');
    }

  }

  /*
    Function: editFamily(family)
    Display the form to edit the family name and blazon

    Parameter:
      family - object, extended family data
  */
  function editFamily(family){
    const settingsContent = document.getElementById("settings_content")!;
    Html.setHtml(settingsContent,TPL_editfamily,family);
    const formElement = settingsContent.querySelector('form') as HTMLFormElement;
    if(formElement){
      formElement.addEventListener('submit', async function(evt){
        evt.preventDefault()
        await ApiServer.accupdatefamily(this)
        segment.track("Family Profile Edited");
        amplify.publish('familyChange')
        libLocation.refresh()
      })
    }

  }

  function displayDownload(family){
    function display(link){
      Html.setHtml(document.getElementById('settings_content'),TPL_download,{deepLoginLink:link});
    }
    ApiServer.accdeeplink('home',display,display);

  }
  function displayNotif(family){
    import("../settings/notification.mustache").then(function(TPL){
      ApiServer.settingsget(function(settings){
        const container = document.getElementById('settings_content');
        Html.setHtml(container,TPL,settings);
        // the onoff widget dispatches a non-bubbling change on its hidden input, hence the capture phase
        container.querySelector('form')?.addEventListener('change', function(evt){
          const input = evt.target as HTMLInputElement;
          if(input?.name?.startsWith('push')){
            segment.track("Setting Notification Toggled",{notification_type:input.name,enabled:input.value==='true'});
          }
        }, true);
      });

    })

  }
  Html.registerDom({
    cookiesettings(){
      //if OneTrust not loaded we want an error
      OneTrust.ToggleInfoDisplay();
    },
    async wipefamily(){
      const opt = await modal.askAsPromise({
        title:'new_confirm_action.title',
        message:i18n.get('settings.circledeleteconfirmtext',FwDatas.getFamily().name),
        button:[{value:"ok",title:'actions.yesdelete',class:"negative"},{title:'actions.nocancel'}]
      });
      if(opt==='ok'){
        var afterWipe = ApiServer.famlistfamily.prepare(true,function(families){
          FwDatas.setFamilies(families)
          if(families.length){
            ApiServer.famlogfamily(families[0].metaId);
            libLocation.goTo('/home.php')
          }else{
            libLocation.goTo('/fw2_signup.php')
          }
        })
        ApiServer.adminwipefamily(afterWipe)
      }
    },
    async premiumcancel(metaId){
      segment.track("Premium Subscription Manage Tapped");
      var credit = FwDatas.get(metaId);
      const answer = await modal.askAsPromise({
        title:'settings.credits.canceltitle',
        message:i18n.get('settings.credits.cancelconfirmation',credit),
        lottie:"images/lottie/crying_face.json",
        button:[
          {title:'settings.credits.cancelpremium',class:"negative",value:"true"},
          {title:'settings.credits.remainpremium',action:'modalclose',class:"secondary"}
        ]});
      if(answer==='true'){
        ApiServer.creditsetautorenewall(metaId,"NONE",displayCredit)
      }
    },
    premiumrenewlink:function(metaId){
      segment.track("Premium Subscription Manage Tapped");
      ApiServer.creditgetmanualrenewalllink(metaId,function(url){
        window.open(url);
      })

    }

  })

  ApiServer["custom.locsetperuserauthflag"] = function(form: HTMLFormElement){
    var
      flags = {},
      tempDuration = {},
      accountId = Html.getDomMetaId(form),
      selectEl = form.querySelector('select') as HTMLSelectElement,
      value = selectEl?.value;

    if(value){
      flags[accountId] = value.split('|')[0];
      if(value.split('|')[1]){
        tempDuration[accountId] = value.split('|')[1];
      }
      ApiServer.locsetperuserauthflag({flags:flags,tempDuration:tempDuration})
    }
  }


  /*
    Function: displayFamilyMembersList(family)
    Display the list of family members

    Parameter:
      family - object, extended family data
  */
  function displayFamilyMembersList(family){
    Html.setHtml(document.getElementById('settings_content'),TPL_members,{family:family});
  }

  /*
    Function: displayAdministratorsList(family)
    Display the list of family members to select administrators

    All administrators are displayed as checked, including the family
    founder, but the family founder cannot be unchecked.

    Parameter:
      family - object, extended family data
  */
  function displayAdministratorsList(family){
    Html.setHtml(document.getElementById('settings_content'),TPL_admin,family);
  }

  async function displayCredit(){
    var credits = await CreditListCache.refresh()
    Html.setHtml(document.getElementById('settings_content'),TPL_credit,{credits:credits,creationDate:FwDatas.getUser().creationDate});

  }
  /*
    Function: displayFamilyStorage(family)
    Display settings for storage quotas

    Parameter:
      family - object, extended family data
  */
  function displayFamilyStorage(family){
    segment.track("Family Storage Viewed");

    class Quota{
      constructor(owner,color,used, total){
        this.owner = owner;
        this.color = color;
        this.used = used||0;
        this.total = total;
        this.percent = Math.min(100,Math.round(100*this.used/this.total));
        this.totalAsString = this.text(this.total)
        this.usedAsString = this.text(this.used)

      }
      text(size){
        var unit = 0, crawler = size;
        while(crawler>1000){
          unit++;
          crawler /= 1000;
        }
        if(crawler<10){
          crawler = Math.round(10*crawler)/10;
        }else{
          crawler = Math.round(crawler);
        }
        return crawler+i18n.get("sizeunit."+['B','KB','MB','GB','TB'][unit]);
      }

    };

    ApiServer.albumquota(function(mediaQuota){
      var membersByQuota = FwDatas.getFamily().members.map(member=>{
        return new Quota(member,null,mediaQuota.usedByOwner[member.accountId],mediaQuota.familyQuota)
      });
      membersByQuota.sort(function(a,b){
        return b.used - a.used;
      });
      var mainQuota = new Quota(FwDatas.getFamily(),mediaQuota.color,mediaQuota.familyUsed,mediaQuota.familyQuota);
      if(mediaQuota.familyQuota<25000000000 && mediaQuota.familyUsed/mediaQuota.familyQuota>0.8){
        mainQuota.proposePremium = true;
      }
      mainQuota.membersByQuota = membersByQuota;

      Html.setHtml(document.getElementById('settings_content'),TPL_quota,mainQuota);
    });

  }

  /*
    Function: displaySettings(data)
    Display settings page

    Parameter:
      data - object, initial page data, produced during start sequence
  */
  function displaySettings(tabId){
    var
      family = FwDatas.getFamily(),
      mapping = {
        settings_edit_family:editFamily,
        settings_edit_members:displayFamilyMembersList,
        settings_edit_admins:displayAdministratorsList,
        settings_edit_quotas:displayFamilyStorage,
        settings_password:displayChangePasswordSection,
        settings_preferences:displayPreferences,
        settings_download:displayDownload,
        settings_notif:displayNotif,
        settings_credits:displayCredit
      };
    if(!Screen.isMobileView()){
      tabId = tabId|| DEFAULT_TAB_ID;
      document.querySelectorAll(".pane-left .selectable>*").forEach(el => el.classList.remove('selected'));
      const selectedTab = document.querySelector(`.pane-left .selectable>*[data-fw-onclick='settings|${tabId}']`);
      if(selectedTab){
        selectedTab.classList.add('selected');
      }
      (mapping[tabId]||editFamily)(family);
    }else if(tabId){
      const paneMain = document.querySelector(".pane-main");
      if(paneMain){
        paneMain.classList.add('open');
      }
      (mapping[tabId]||editFamily)(family);
    }else{
      const paneMain = document.querySelector(".pane-main");
      if(paneMain){
        paneMain.classList.remove('open');
      }
    }
  }


  INR.onPage(INR.URL.SETTINGS,function(){

    INR.subscribe ("familyMemberSelected", function(event){
      if(event.selected!=="all"){
        Html.trigger(null,'modaluser', [event.selected]);
      }
    });

    INR.subscribe("rightsUpdated",function(){
      displaySettings('settings_edit_admins')
    });
    INR.subscribe("handleParam",function(){
      displaySettings(libLocation.getURLParam('tab'));
    });
    amplify.publish("handleParam")

  });
  Html.registerDom({
    settings:function(tabId){
      libLocation.goTo('?tab='+tabId,!Screen.isMobileView());
    },
    adminchangeright:async function(){
      const value = (this as HTMLInputElement).value;
      const metaId = Html.getDomMetaId(this);
      const newRole = (value==="true")?"Admin":"None";
      try{
        await ApiServer.adminchange(newRole,[metaId]);
        segment.track("Family Member Role Changed",{new_role:segment.enumValue(newRole)});
      }finally{
        //refreshed even on failure, so that the toggle shows the actual role
        ApiServer.accgetallfamily(true,function(extentedFamily) {
          FwDatas.setFamily(extentedFamily);
        });
      }
    }
  })